import EarlyAccess from '../../src/legacy/EarlyAccess.tsx';
export default EarlyAccess;
